<template>
    <popup-wrapper
        class="popup-save-name"
        v-if="popShow"
        @pop-cls="handlePopCls"
        :size="'mid'"
        :hasCls="false"
    >
        <h3>{{ $t('popup.inputNameTips') }}</h3>
        <div class="input-wrapper">
            <input
                type="text"
                name="username"
                :placeholder="$t('base.enter_name')"
                autocomplete="off"
                v-model="username"
            />
        </div>
        <div class="btn-confirm" @click="handleConfirmName">
            {{ $t('base.confirm_btn') }}
        </div>
    </popup-wrapper>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import popupWrapper from '@/components/popup/popup-wrapper';
import i18n from '@/lang';

export default {
    name: 'popup-save-name',
    data() {
        return {
            username: ''
        };
    },
    components: {
        popupWrapper
    },
    computed: {
        popShow() {
            return this.$store.state.popup.saveName;
        }
    },
    methods: {
        ...mapMutations(['SET_STATE', 'PLAY_SOUND', 'STOP_SOUND']),
        ...mapActions(['saveName']),
        handlePopCls() {
            this.$store.commit('HIDE_ALL_POPUP');
        },
        // 保存用户名
        handleConfirmName() {
            this.PLAY_SOUND('button');
            if (!this.username) {
                alert(i18n.t('base.enter_name'));
            } else {
                this.saveName({
                    name: this.username
                });
                this.SET_STATE({
                    key: 'toolbarType',
                    val: 'selectPet'
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
/deep/ .popup-wrapper {
    box-sizing: border-box;
    padding: 30px 40px;

    h3 {
        font-size: 28px;
        text-align: center;
        line-height: 1.8;
        color: #9c9273;
    }
    .input-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 32px;
        margin-left: 12px;

        input {
            width: 344px;
            height: 55px;
            background: url(~@/assets/img/pop_input_bg.png) center/100% 100%
                no-repeat;
            padding-left: 20px;
            box-sizing: border-box;
            font-size: 24px;
            line-height: 55px;
            color: #9c9273;
            flex-shrink: 0;

            &::-webkit-input-placeholder {
                color: #e7e2d0;
            }
        }
    }
    .btn-confirm {
        width: 160px;
        height: 63px;
        background: url(~@/assets/img/btn_blue_square.png) center/100% 100%
            no-repeat;
        margin: 40px auto 0;
        line-height: 63px;
        font-size: 36px;
        color: #fff;
        text-align: center;
        font-weight: bold;
    }
}
</style>
